import { render, staticRenderFns } from "./CardBarsStack.vue?vue&type=template&id=2d775874&scoped=true"
import script from "./CardBarsStack.vue?vue&type=script&lang=ts"
export * from "./CardBarsStack.vue?vue&type=script&lang=ts"
import style0 from "./CardBarsStack.vue?vue&type=style&index=0&id=2d775874&prod&lang=css"
import style1 from "./CardBarsStack.vue?vue&type=style&index=1&id=2d775874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d775874",
  null
  
)

export default component.exports